var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card" },
    [
      _c("TabList", {
        attrs: { "current-tab": _vm.currentTab, tabs: _vm.tabList },
        on: { "update:tab": _vm.updateTab },
      }),
      _c("DonationRecord", {
        attrs: {
          "current-tab": _vm.currentTab,
          "table-data": _vm.currentTableData,
          "table-columns": _vm.currentTableColumns,
          "table-options": _vm.options,
          "member-area-data": _vm.memberAreaData,
        },
      }),
      _c("ReceiptStatus", {
        attrs: {
          "current-tab": _vm.currentTab,
          "table-data": _vm.currentTableData,
          "table-columns": _vm.currentTableColumns,
          "table-options": _vm.options,
        },
      }),
      _c("CardInfo", {
        attrs: {
          "current-tab": _vm.currentTab,
          "recurring-data": _vm.recurringData,
        },
      }),
      _c("PersonalInfo", {
        attrs: {
          "current-tab": _vm.currentTab,
          "member-contact-data": _vm.memberContactData,
        },
      }),
      _c("PendingPayment", {
        attrs: {
          "current-tab": _vm.currentTab,
          "table-data": _vm.currentTableData,
          "table-columns": _vm.currentTableColumns,
          "table-options": _vm.options,
          "member-area-data": _vm.memberAreaData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }